// Vendors
import React, { useState } from 'react';

const ApplicationCard = ({
  application: {
    aid,
    status,
    address,
    equipmentType,
    state,
    created,
    submittedDate,
    incentiveAmount,
    permalink,
    serialNumber,
    producer
  },
  selectable = false,
  selected = false,
  onClickHandler = () => {}
}) => {
  const [isSelected, setIsSelected] = useState(selected);

  const formatEquipmentType = (type, snake = false) => {
    let replace = snake ? '_$1' : ' $1';
    type = type.replace(/([A-Z])/g, replace).trim();

    return snake
      ? type.toLowerCase()
      : type.charAt(0).toUpperCase() + type.slice(1);
  };

  return (
    <div className="grid__col-xs-12 grid__col-xl-6">
      <div
        className={`card-project card-project--${
          status && status.toLowerCase()
        }${selectable ? ' card-project--selectable' : ''} ${
          isSelected ? ' card-project--selected' : ''
        }`}
        onClick={() => {
          if (selectable) {
            setIsSelected(!selected);
            onClickHandler(aid);
          }
        }}
      >
        <div className="card-project__address">
          <div className="card-project__street">{address}</div>
          <span>
            {formatEquipmentType(equipmentType)} - {serialNumber}
          </span>
          {Object.keys(producer).length !== 0 && (
            <>
              <br />
              <span
                className="u--font-size-sm"
                dangerouslySetInnerHTML={{
                  __html: `${
                    producer.first_name ? producer.first_name : '&nbsp;'
                  }
                  ${producer.last_name ? producer.last_name : '&nbsp;'}
                  ${
                    producer.user_email ? `(${producer.user_email})` : '&nbsp;'
                  }${state ? ` <b>${state}</b>` : '&nbsp;'}
                  <br />${producer.company ? producer.company : '&nbsp;'}`
                }}
              />
            </>
          )}
        </div>
        <div className="card-project__status">
          <span className="card-project__status-indicator">
            {status ?? 'In Progress'}
          </span>
        </div>
        <div className="card-project__completion-date">
          <div>
            Date Created:{' '}
            <span>
              {created
                ? new Date(created).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                  })
                : ''}
            </span>
          </div>
        </div>
        <div className="card-project__completion-date">
          <div>
            Application Submitted:{' '}
            <span>
              {submittedDate
                ? new Date(submittedDate).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                  })
                : ''}
            </span>
          </div>
        </div>
        <div className="card-project_qualify-for">
          <div>
            Qualifying for{' '}
            <span className="card-project_qualify-amount">
              {parseInt(incentiveAmount) > 0
                ? `$${parseInt(incentiveAmount).toLocaleString()}`
                : 'TBD'}
            </span>
          </div>
        </div>
        {selectable === false && (
          <div className="card-project__view-details">
            <a
              href={permalink}
              className="btn btn--link btn--sm btn--has-arrow module-hover-root"
            >
              <span className="btn__content">
                <span className="btn__text">View/Edit Details</span>
                <span className="btn__arrow arrow"></span>
              </span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationCard;
